<template>
  <b-dropdown position="is-bottom-left" class="has-text-left">
    <template #trigger="{ active }">
      <b-button
        label="Manage"
        :type="type"
        :append-to-body="true"
        :icon-right="active ? 'menu-up' : 'menu-down'"
        outlined
      ></b-button>
    </template>
    <!-- Always Actions -->
    <b-dropdown-item has-link>
      <b-dropdown-item  @click="$emit('position:edit', position)">Manage Budget</b-dropdown-item>
    </b-dropdown-item>
    <hr class="dropdown-divider">
    <!-- <b-dropdown-item @click="workflowAction('position:seat')">Add Contributor</b-dropdown-item>
    <b-dropdown-item @click="workflowAction('position:delivery')">Add Delivery</b-dropdown-item>
    <b-dropdown-item @click="workflowAction('position:expense')">Add Expense</b-dropdown-item>
    <hr class="dropdown-divider"> -->
    <b-dropdown-item @click="workflowAction('position:allocate')">Allocate</b-dropdown-item>
    <!-- Active Actions -->
    <template v-if="position.status === 'active'">
      <hr class="dropdown-divider">
      <b-dropdown-item @click="workflowAction('position:pause')">Pause</b-dropdown-item>
    </template>
    <!-- Paused Actions -->
    <template v-if="position.status === 'paused'">
      <hr class="dropdown-divider">
      <b-dropdown-item @click="workflowAction('position:restart')">Restart</b-dropdown-item>
    </template>
    <!-- Pending Actions -->
    <template v-if="position.status === 'pending'">
      <hr class="dropdown-divider">
      <b-dropdown-item @click="workflowAction('position:activate')">Activate</b-dropdown-item>
      <b-dropdown-item @click="workflowAction('position:archive')" class="has-text-danger">Remove</b-dropdown-item>
    </template>
    <!-- IDs -->
    <template v-if="canCopy">
      <hr class="dropdown-divider">
      <b-dropdown-item  @click="copy(position.id)">Copy Budget ID</b-dropdown-item>
    </template>
    <template>
      <hr class="dropdown-divider">
      <b-dropdown-item custom>
        <span class="has-text-grey-light">ID: {{ position.id }}</span>
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['context']),
    canCopy () {
      return (navigator.clipboard && window.isSecureContext)
    }
  },
  data () {
    return {}
  },
  methods: {
    workflowAction (action) {
      this.$emit(action, this.position)
    },
    copy (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Copied!' })
      })
    }
  },
  mounted () {

  },
  props: {
    projectId: {
      type: Number,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    type: {
      type: [String, null],
      default: 'is-ghost'
    }
  }
}
</script>
